import { theme } from '/../tailwind.config.js'
import Images from '/data/images'

const IMAGE_RES = generateImageRes()

//private
function generateImageRes() {
  const pixelDensity = window.devicePixelRatio

  if (pixelDensity > 1) {
    return 'hiRes'
  } else {
    return 'defaultRes'
  }
}

// public
function hyphenateString(string) {
  return string.replace(/\s/g, '-').toLowerCase()
}

function isMobile() {
  return window.matchMedia(`(max-width: ${theme.screens.md})`).matches
}

function isTablet() {
  return window.matchMedia(`(max-width: ${theme.screens.lg})`).matches
}

function generateThemeClasses(color) {
  switch (color) {
    case 'gator-orange':
      return {
        textColor: 'text-gator-orange-text',
        textFullColor: 'text-gator-orange',
        textSmallColor: 'text-gator-orange-small',
        bgColor: 'bg-gator-orange',
        bgColorHover: 'hover:bg-gator-orange',
        borderColor: 'border-gator-orange',
        hex: theme.colors['gator-orange']
      }
    case 'asparagus-green':
      return {
        textColor: 'text-asparagus-green-text',
        textFullColor: 'text-asparagus-green',
        textSmallColor: 'text-asparagus-green-small',
        bgColor: 'bg-asparagus-green',
        bgColorHover: 'hover:bg-asparagus-green',
        borderColor: 'border-asparagus-green',
        hex: theme.colors['asparagus-green']
      }
    case 'tufts-blue':
      return {
        textColor: 'text-tufts-blue-text',
        textFullColor: 'text-tufts-blue',
        textSmallColor: 'text-tufts-blue-small',
        bgColor: 'bg-tufts-blue',
        bgColorHover: 'hover:bg-tufts-blue',
        borderColor: 'border-tufts-blue',
        hex: theme.colors['tufts-blue']
      }
    case 'goldenrod-yellow':
      return {
        textColor: 'text-goldenrod-yellow-text',
        textFullColor: 'text-goldenrod-yellow',
        textSmallColor: 'text-goldenrod-yellow-small',
        bgColor: 'bg-goldenrod-yellow',
        bgColorHover: 'hover:bg-goldenrod-yellow',
        borderColor: 'border-goldenrod-yellow',
        hex: theme.colors['goldenrod-yellow']
      }
    default:
      return {
        textColor: 'text-danaher-blue',
        textFullColor: 'text-danaher-blue',
        textSmallColor: 'text-danaher-blue',
        bgColor: 'bg-danaher-blue',
        bgColorHover: 'hover:bg-danaher-blue',
        borderColor: 'border-danaher-blue',
        hex: theme.colors['danaher-blue']
      }
  }
}

function generateBgImage(imageKey) {
  if (!imageKey) {
    return null
  }

  const imageUrl = Images[imageKey][IMAGE_RES]

  if (!imageUrl) {
    return null
  }

  return { backgroundImage: `url(${imageUrl})` }
}

function generateSiblingPages(currentPage, routes) {
  const currentRoute = currentPage.location.pathname
  let routeIndex = null
  let prevPage = {}
  let nextPage = {}

  for (var i = 0; i < routes.length; i++) {
    if (routes[i].url === currentRoute) {
      routeIndex = i
    }
  }

  prevPage =
    routeIndex - 1 >= 0 ? routes[routeIndex - 1] : routes[routes.length]
  nextPage = routeIndex + 1 < routes.length ? routes[routeIndex + 1] : routes[0]
  return { prevPage, nextPage }
}

export {
  hyphenateString,
  isMobile,
  isTablet,
  generateThemeClasses,
  generateBgImage,
  generateSiblingPages
}
